import React from "react";
import Overlay from "../../components/Overlay/Overlay";
import Button from "../../components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import {clearErrorOverlay} from "../../store/app/actions";

export default function ErrorOverlay () {
  const dispatch = useDispatch();
  const error = useSelector(state => state.app.error);
  if(!error){
    return null;
  }
  // dispatch(setErrorOverlay({messages, refID}))

  let messages = []
  if(error.messages && error.messages.length === 1){
    messages.push(<div>{error.messages[0]}</div>)
  }else{
    messages.push(<p><b>The following errors occurred:</b></p>)
    messages.push(error.messages.map( message => {
      return <li>{message}</li>
    }))
  }

  if(error.refID){
    messages.push(<span><br />Ref: {error.refID}</span>)
  }
  return <Overlay
    type='error'
    style={{ fontSize: 96 }}
    message={messages}
    dismiss={<Button
      type="submit"
      color="primary"
      simple
      size="lg"
      block
      variant="contained"
      onClick={() => dispatch(clearErrorOverlay())}
    >
      OKAY
    </Button>}
  />
}